/* =========================================================================
   SmartHome-Energy — Collection / PLP
   Filter (Shopify Facets), Sortierung, Mehr laden, Mobile-Drawer, SEO-Toggle.
   Nutzt die Section Rendering API (?section_id=) — kein Framework, kein jQuery.
   ========================================================================= */
(function () {
  "use strict";

  if (window.__sheCollectionInit) return;
  window.__sheCollectionInit = true;

  var SEL = {
    root: "[data-she-plp]",
    form: "[data-she-facet-form]",
    results: "[data-she-results]",
    chips: "[data-she-chips]",
    count: "[data-she-count]",
    facetsWrap: "[data-she-facets-wrap]",
    openFilters: "[data-she-open-filters]",
    closeFilters: "[data-she-close-filters]",
    scrim: "[data-she-facets-scrim]",
    sort: "[data-she-sort]",
    loadMore: "[data-she-loadmore]",
    pager: "[data-she-pager]",
    grid: "[data-she-grid]",
    more: "[data-she-more]",
    activeCount: "[data-she-active-count]",
    seo: "[data-she-seo]"
  };

  var reduceMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ------------------------------------------------------------------ *
     Hilfsfunktionen
   * ------------------------------------------------------------------ */
  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this,
        args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function paramsFromForm(form) {
    var params = new URLSearchParams();
    var data = new FormData(form);
    data.forEach(function (value, key) {
      if (value === null || value === undefined) return;
      var v = String(value).trim();
      if (v === "") return;
      params.append(key, v);
    });
    return params;
  }

  /* ------------------------------------------------------------------ *
     PLP-Controller
   * ------------------------------------------------------------------ */
  function Plp(root) {
    this.root = root;
    this.sectionId = root.getAttribute("data-section-id");
    this.abort = null;
    this.bind();
  }

  Plp.prototype.q = function (sel) {
    return this.root.querySelector(sel);
  };
  Plp.prototype.qa = function (sel) {
    return Array.prototype.slice.call(this.root.querySelectorAll(sel));
  };

  Plp.prototype.bind = function () {
    var self = this;

    // Delegierte Events — überleben jedes Neurendern des Inhalts.
    this.root.addEventListener("change", function (e) {
      var t = e.target;
      if (!t) return;
      if (t.closest && t.closest(SEL.form)) {
        if (t.type === "number" || t.type === "text") return; // via input+debounce
        self.apply();
        return;
      }
      if (t.matches && t.matches(SEL.sort)) {
        self.apply();
      }
    });

    var debouncedApply = debounce(function () {
      self.apply();
    }, 550);
    this.root.addEventListener("input", function (e) {
      var t = e.target;
      if (t && t.closest && t.closest(SEL.form) && (t.type === "number" || t.type === "text")) {
        debouncedApply();
      }
    });

    this.root.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var open = t.closest(SEL.openFilters);
      if (open) {
        e.preventDefault();
        self.openDrawer();
        return;
      }
      if (t.closest(SEL.closeFilters) || t.closest(SEL.scrim)) {
        e.preventDefault();
        self.closeDrawer();
        return;
      }

      var more = t.closest(SEL.more);
      if (more) {
        e.preventDefault();
        self.toggleMore(more);
        return;
      }

      var chip = t.closest("[data-she-facet-link]");
      if (chip && chip.getAttribute("href")) {
        e.preventDefault();
        self.applyUrl(chip.getAttribute("href"));
        return;
      }

      var lm = t.closest(SEL.loadMore);
      if (lm && lm.getAttribute("href")) {
        e.preventDefault();
        self.loadMore(lm);
        return;
      }
    });

    this.root.addEventListener("submit", function (e) {
      if (e.target && e.target.matches && e.target.matches(SEL.form)) {
        e.preventDefault();
        self.apply();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") self.closeDrawer();
    });

    window.addEventListener("popstate", function () {
      self.fetchAndRender(window.location.pathname + window.location.search, false);
    });
  };

  /* ---- Filter anwenden ---- */
  Plp.prototype.apply = function () {
    var form = this.q(SEL.form);
    var params = form ? paramsFromForm(form) : new URLSearchParams();
    var sort = this.q(SEL.sort);
    if (sort && sort.value) params.set("sort_by", sort.value);
    var url = window.location.pathname + (params.toString() ? "?" + params.toString() : "");
    this.applyUrl(url);
  };

  Plp.prototype.applyUrl = function (url) {
    this.fetchAndRender(url, true);
  };

  Plp.prototype.fetchAndRender = function (url, push) {
    var self = this;
    var results = this.q(SEL.results);
    if (!results) return;

    if (this.abort) this.abort.abort();
    this.abort = new AbortController();

    results.classList.add("is-loading");
    results.setAttribute("aria-busy", "true");

    var sep = url.indexOf("?") === -1 ? "?" : "&";
    var fetchUrl = url + sep + "section_id=" + encodeURIComponent(this.sectionId);

    fetch(fetchUrl, { signal: this.abort.signal, headers: { "X-Requested-With": "fetch" } })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newRoot = doc.querySelector(SEL.root);
        if (!newRoot) throw new Error("Section-Antwort ohne PLP-Wurzel");

        self.swap(newRoot, SEL.results);
        self.swap(newRoot, SEL.chips);
        self.swap(newRoot, SEL.count);
        self.swapFacets(newRoot);
        self.syncSort(newRoot);

        if (push) {
          try {
            window.history.pushState({ sheUrl: url }, "", url);
          } catch (err) {
            /* noop */
          }
        }
        results.classList.remove("is-loading");
        results.removeAttribute("aria-busy");
        self.announce();
        document.dispatchEvent(new CustomEvent("she:collection:updated", { detail: { url: url } }));
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        // Harter Fallback: normale Navigation, damit der Nutzer nie festhängt.
        window.location.href = url;
      });
  };

  Plp.prototype.swap = function (newRoot, sel) {
    var oldEl = this.q(sel);
    var newEl = newRoot.querySelector(sel);
    if (!oldEl || !newEl) return;
    oldEl.innerHTML = newEl.innerHTML;
  };

  /* Filter neu einsetzen, dabei geöffnete Gruppen und Scrollposition erhalten. */
  Plp.prototype.swapFacets = function (newRoot) {
    var oldForm = this.q(SEL.form);
    var newForm = newRoot.querySelector(SEL.form);
    if (!oldForm || !newForm) return;

    var openState = {};
    this.qa(SEL.form + " details[data-facet-key]").forEach(function (d) {
      openState[d.getAttribute("data-facet-key")] = d.open;
    });
    var scroller = oldForm.closest("[data-she-facets-scroll]") || oldForm.parentElement;
    var scrollTop = scroller ? scroller.scrollTop : 0;

    oldForm.innerHTML = newForm.innerHTML;

    Array.prototype.forEach.call(oldForm.querySelectorAll("details[data-facet-key]"), function (d) {
      var k = d.getAttribute("data-facet-key");
      if (Object.prototype.hasOwnProperty.call(openState, k)) d.open = openState[k];
    });
    if (scroller) scroller.scrollTop = scrollTop;

    var badge = this.q(SEL.activeCount);
    var newBadge = newRoot.querySelector(SEL.activeCount);
    if (badge && newBadge) {
      badge.textContent = newBadge.textContent;
      badge.hidden = newBadge.hidden;
    }
  };

  Plp.prototype.syncSort = function (newRoot) {
    var oldSort = this.q(SEL.sort);
    var newSort = newRoot.querySelector(SEL.sort);
    if (oldSort && newSort && oldSort.value !== newSort.value) oldSort.value = newSort.value;
  };

  Plp.prototype.announce = function () {
    var live = this.q("[data-she-live]");
    var count = this.q(SEL.count);
    if (live && count) live.textContent = count.textContent.trim();
  };

  /* ---- Mehr laden ---- */
  Plp.prototype.loadMore = function (btn) {
    var self = this;
    var url = btn.getAttribute("href");
    var grid = this.q(SEL.grid);
    var pager = this.q(SEL.pager);
    if (!url || !grid) return;

    btn.setAttribute("aria-busy", "true");
    var label = btn.querySelector("[data-she-loadmore-label]");
    var original = label ? label.textContent : null;
    if (label) label.textContent = "Wird geladen …";

    fetch(url + (url.indexOf("?") === -1 ? "?" : "&") + "section_id=" + encodeURIComponent(this.sectionId))
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newGrid = doc.querySelector(SEL.grid);
        var newPager = doc.querySelector(SEL.pager);
        if (newGrid) {
          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(newGrid.children, function (li) {
            frag.appendChild(li.cloneNode(true));
          });
          grid.appendChild(frag);
        }
        if (pager && newPager) {
          pager.innerHTML = newPager.innerHTML;
        } else if (pager) {
          pager.innerHTML = "";
        }
        // Bewusst KEIN history-Update: die URL soll beim Neuladen weiterhin
        // Seite 1 zeigen, nicht nur die nachgeladene Seite.
        document.dispatchEvent(new CustomEvent("she:collection:appended"));
      })
      .catch(function () {
        if (label && original) label.textContent = original;
        window.location.href = url;
      })
      .finally(function () {
        btn.removeAttribute("aria-busy");
        self.observeInfinite();
      });
  };

  Plp.prototype.observeInfinite = function () {
    var self = this;
    if (this.root.getAttribute("data-infinite") !== "true") return;
    var btn = this.q(SEL.loadMore);
    if (!btn) return;
    if (this.io) this.io.disconnect();
    this.io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            self.io.disconnect();
            self.loadMore(btn);
          }
        });
      },
      { rootMargin: Math.round(window.innerHeight * 1.2) + "px 0px" }
    );
    this.io.observe(btn);
  };

  /* ---- Mobile Drawer ---- */
  Plp.prototype.openDrawer = function () {
    var wrap = this.q(SEL.facetsWrap);
    if (!wrap) return;
    this.lastFocus = document.activeElement;
    wrap.classList.add("is-open");
    wrap.setAttribute("aria-hidden", "false");
    document.body.classList.add("she-noscroll");
    var close = wrap.querySelector(SEL.closeFilters);
    if (close) close.focus();
  };

  Plp.prototype.closeDrawer = function () {
    var wrap = this.q(SEL.facetsWrap);
    if (!wrap || !wrap.classList.contains("is-open")) return;
    wrap.classList.remove("is-open");
    wrap.setAttribute("aria-hidden", "true");
    document.body.classList.remove("she-noscroll");
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  /* ---- "Mehr anzeigen" innerhalb einer Filtergruppe ---- */
  Plp.prototype.toggleMore = function (btn) {
    var list = btn.previousElementSibling;
    if (!list) return;
    var expanded = btn.getAttribute("aria-expanded") === "true";
    Array.prototype.forEach.call(list.querySelectorAll("[data-overflow]"), function (li) {
      li.hidden = expanded;
    });
    btn.setAttribute("aria-expanded", expanded ? "false" : "true");
    btn.textContent = expanded
      ? btn.getAttribute("data-label-more")
      : btn.getAttribute("data-label-less");
  };

  /* ------------------------------------------------------------------ *
     SEO-Text ein-/ausklappen
   * ------------------------------------------------------------------ */
  function initSeo(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll(SEL.seo), function (el) {
      if (el.__sheBound) return;
      el.__sheBound = true;
      var body = el.querySelector(".she-cseo__body");
      var toggle = el.querySelector(".she-cseo__toggle");
      if (!body || !toggle) return;
      // Nur klemmen, wenn der Text wirklich länger ist als die Klemmhöhe.
      if (body.scrollHeight <= body.clientHeight + 24 && el.classList.contains("she-cseo--clamped")) {
        el.classList.remove("she-cseo--clamped");
        toggle.hidden = true;
        return;
      }
      toggle.addEventListener("click", function () {
        var expanded = el.classList.toggle("is-expanded");
        toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
        var label = toggle.querySelector("[data-label]");
        if (label) {
          label.textContent = expanded
            ? toggle.getAttribute("data-label-less")
            : toggle.getAttribute("data-label-more");
        }
        if (!expanded && !reduceMotion) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });
  }

  /* ------------------------------------------------------------------ *
     Karten-ATC (nutzt product-form.js des Themes, falls vorhanden;
     sonst eigener leichter Fetch auf /cart/add.js)
   * ------------------------------------------------------------------ */
  function initCardAtc(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll("[data-she-atc]"), function (form) {
      if (form.__sheBound) return;
      form.__sheBound = true;
      form.addEventListener("submit", function (e) {
        // Wenn das Theme-Element <product-form> aktiv ist, macht das dessen JS.
        if (form.closest("product-form") && window.customElements && customElements.get("product-form")) {
          return;
        }
        e.preventDefault();
        var btn = form.querySelector("[type=submit]");
        var err = form.parentElement.querySelector("[data-she-atc-error]");
        if (err) {
          err.textContent = "";
          err.hidden = true;
        }
        if (btn) {
          btn.setAttribute("aria-busy", "true");
          btn.disabled = true;
        }
        var routes = (window.theme && window.theme.routes) || {};
        var addUrl = routes.cartAdd || "/cart/add.js";
        fetch(addUrl, {
          method: "POST",
          headers: { Accept: "application/javascript", "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams(new FormData(form)).toString()
        })
          .then(function (r) {
            return r.json().then(function (d) {
              return { ok: r.ok, data: d };
            });
          })
          .then(function (res) {
            if (!res.ok) throw new Error((res.data && res.data.description) || "Fehler");
            document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
            document.dispatchEvent(
              new CustomEvent("dispatch:cart-drawer:open", { detail: { opener: btn } })
            );
            document.dispatchEvent(new CustomEvent("on:cart:add", { detail: res.data }));
          })
          .catch(function (ex) {
            if (err) {
              err.textContent = ex.message || "Konnte nicht in den Warenkorb gelegt werden.";
              err.hidden = false;
            }
          })
          .finally(function () {
            if (btn) {
              btn.removeAttribute("aria-busy");
              btn.disabled = false;
            }
          });
      });
    });
  }

  /* ------------------------------------------------------------------ *
     Sticky-Offset aus der Headerhöhe berechnen
   * ------------------------------------------------------------------ */
  function setStickyOffset() {
    var header =
      document.querySelector(".she-hdr") ||
      document.querySelector("[data-sticky-header]") ||
      document.querySelector("#shopify-section-header, #shopify-section-she-header");
    var h = 0;
    if (header) {
      var cs = window.getComputedStyle(header);
      if (cs.position === "sticky" || cs.position === "fixed") h = header.offsetHeight;
    }
    document.documentElement.style.setProperty("--she-sticky-top", (h + 12) + "px");
  }

  /* ------------------------------------------------------------------ *
     Boot
   * ------------------------------------------------------------------ */
  function boot(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll(SEL.root), function (root) {
      if (root.__shePlp) return;
      root.__shePlp = new Plp(root);
      root.__shePlp.observeInfinite();
    });
    initSeo(scope);
    initCardAtc(scope);
    setStickyOffset();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("she:collection:updated", function () {
    initCardAtc(document);
  });
  document.addEventListener("she:collection:appended", function () {
    initCardAtc(document);
  });
  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target || document);
  });
  window.addEventListener("resize", debounce(setStickyOffset, 200));
})();
